// extracted by css-extract-rspack-plugin
export default {"label":"label-Qtiog4","labelClickable":"labelClickable-mHP2A_","value":"value-X2n54I","valueInProgress":"valueInProgress-y_P3qY"};